import { Stitch } from '../../types/pattern';
import { STITCH_CONSTANTS } from '../../utils/stitchConstants';
import { drawSvgStitch } from '../../stitches/svg-renderer';
import { fallbackRenderer } from '../../stitches/canvas-renderers';

interface DrawStitchProps {
  ctx: CanvasRenderingContext2D;
  stitch: Stitch | { type: string; color?: string };
  isSelected?: boolean;
  color?: string;
  stitchScale?: number;
}

export const drawStitch = ({ ctx, stitch, isSelected, color, stitchScale }: DrawStitchProps) => {
  const { STROKE_WIDTH } = STITCH_CONSTANTS;
  const strokeColor = color || (stitch as Stitch).color || '#666666';

  // Selected: draw a slightly larger version in highlight color behind the stitch
  if (isSelected) {
    ctx.save();
    const biggerScale = (stitchScale || 1.5) * 1.3;
    if (!drawSvgStitch(ctx, stitch.type, '#009eb3', biggerScale)) {
      ctx.globalAlpha = 0.4;
      ctx.strokeStyle = '#009eb3';
      ctx.lineWidth = STROKE_WIDTH.CANVAS * 2;
      fallbackRenderer(ctx, '#009eb3');
    }
    ctx.restore();
  }

  // Draw the actual stitch
  if (drawSvgStitch(ctx, stitch.type, strokeColor, stitchScale)) {
    return;
  }

  // Fallback to dot rendering
  ctx.strokeStyle = strokeColor;
  ctx.lineWidth = STROKE_WIDTH.CANVAS;
  ctx.globalAlpha = 0.7;
  fallbackRenderer(ctx, strokeColor);
};
